import moment from "moment";

  export const PROVISIONAL_MONTH = 0
    
  export const dateFormatter = value => {
    if (!value) return '-'
    return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }
  
  export const currencyFormatter = params => {
    let value = params.value

    if (!value && value !== 0) return 0
    if (typeof value === 'string' && value.includes(','))
      value = value.replaceAll(',', '')
    var twoDecimals = parseFloat(value).toFixed(2)
    if (isNaN(twoDecimals)) return 'Número invalido'
    var formatPrice = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    }).format(twoDecimals)
    return `$ ${formatPrice}`
  };
  
  export const currencyCheck = params => (params.value ? currencyFormatter(params) : '-');
  export const stringFormatter = (params) => params.value || '-'
  export const stringCurrencyFormatter = (value) => {
    if (!value) return 0

    if (typeof value === 'string' && value.includes(','))
      value = value.replaceAll(',', '')
    var twoDecimals = parseFloat(value).toFixed(2)
    if (isNaN(twoDecimals)) return 'Número invalido'
    var formatPrice = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    }).format(twoDecimals)
    return `$ ${formatPrice}`
  }

  export const monthFormatter = (value) => {
    const months = [
      'Provisoria',
      'Enero',
      'Febrero', 
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre'
    ]
    return months[Number(value)] || '-'
  }

  export const ROLES = {
    ROLE_SUPER_ADMIN: 'super-admin',
  }

  export const PERMISSIONS = {
    EDIT_CAMPAIGN_COMMENTS: 'edit_campaign_comment',
  }
  
  